import { createContext } from "react";
import type Cookies from "universal-cookie";

import type {
  AnjouanLicensingData,
  AuthFeatureData,
  BreadcrumbsStaticTranslations,
} from "~/core";
import type { GetSettingsQuery as GetSettingsQuerySdk } from "~/core/sdk";
import type { SiteSdk } from "~/core/site-sdk";
import type { CfProxyData } from "~/server/extract-cf-headers";
import type { FlagsClient } from "~/shared/utils/feature-flags/core";

export type ClientContextData = {
  affiliate?: string;
  featureFlags: FlagsClient;
  authToken?: string;
  loginToken?: string;
  cookies: Cookies;
  breadcrumbsStaticTranslations: BreadcrumbsStaticTranslations;
  playerID?: string;
  amount?: string;
  paymentMethod?: string;
  errorMessage?: string;
  statusCode?: string;
  transactionId?: string;
  windowType?: string;
  authFeatures: AuthFeatureData;
  cfProxyData: CfProxyData;
  language: string;
  siteSdk: SiteSdk;
  availableLanguages: Array<string>;
  languages: GetSettingsQuerySdk["languages"];
  isNewUser: boolean;
  anjouanLicensingData?: AnjouanLicensingData;
};

export const ClientContext = createContext<null | ClientContextData>(null);
